import React, { useState } from "react";
import classes from "./VerifyPage.module.css";
import { useLocation } from "react-router-dom";
import img from "../../assets/resetpassword.png";
import { Button, Checkbox, Form, Input } from "antd";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import axios from "axios";
import data from '../Data.json'
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

const ResendVerifyPage = () => {
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);

    const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    // console.log(JSON.stringify(values));
    const body = JSON.stringify(values);
    try {
      // Send a request to your backend API to reset the password
      const response = await axios.post(
        `${process.env.REACT_APP_TESTING_API}/forgot-password`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.data;
      // console.log(data);
      // Check if the request was successful
    if (response.status >= 200 && response.status < 300) {
        navigate("/login");
        // Reset the form and show success message
        toast.success(data[1] , {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        });
        // Optionally, redirect the user to a login page or home page
      } else {
        // Show error message if the request failed
        toast.error(data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error(error.response.data.error.email[0] , {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };
  const [reloading, setreLoading] = useState(false);

  const handleResend = async () => {
    const email = localStorage.getItem('unverifiedEmail');
    
    try {
      setreLoading(true); // Start loading state
  
      const updatedFormData = { email: email, type: `${process.env.REACT_APP_ECOM_TYPE}` };
      const response = await axios.post(`${process.env.REACT_APP_TESTING_API}/email/verification-notification`, updatedFormData);
      // Check if the response indicates success (assuming based on HTTP status code, adjust if needed)
      toast.info(`${language === 'eng' ? "E-mail resent" : "E-mail renvoyé"}`,{hideProgressBar:true})
    } catch (error) {
      // console.error('Error resending verification email:', error);
      toast.error(error.response.data.error, { hideProgressBar: true });
    } finally {
      setreLoading(false); // Always stop loading state, regardless of success or failure
    }
  };
  return (
    <div className={classes.login_con}>
      <Helmet>
        <h1>Resend Verification - Novagryph</h1>
        <title>Resend Verification - Novagryph</title>
        <meta name="description" content="Resend your email verification for Novagryph account." />
      </Helmet>
      <div className={classes.header}>
        <div className={classes.headtitle}>{language === 'eng' ? "VERIFY YOUR EMAIL" : "VÉRIFIEZ VOTRE E-MAIL"}</div>
        <div className={classes.border} />
      </div>
      <div className={classes.cardsContainer}>
        <div className={classes.registerImage}>
          <div className={classes.registerImageimg}>
            <img
              src={img}
              alt="registerImage"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
            <div className={classes.blurre} />
          </div>
        </div>

        <div className={classes.card}>
          <div className={classes.subtitle}>
            <h1 style={{textTransform:"capitalize"}}>
                {language === 'eng' ? "Verify E-mail" : "Vérifiez Votre E-Mail"}  </h1>
            <p
              style={{
                fontSize: "calc(0.6rem + 0.4vw)",
                width: "80%",
                margin: "auto",
              }}
            >
             {language === 'eng' ? "Please click on “Send email,” then check your inbox and click on the link to activate your account." : "Veuillez cliquer sur « Envoyer l'e-mail », puis vérifier votre boîte de réception et cliquer sur le lien pour activer votre compte."} 
            </p>        

          <Button
                  size="large"
                  onClick={handleResend}
                  className="login-form-button"
                  style={{
                    backgroundColor: "var(--primary-color)",
                    color: "white",
                    height: "3em",
                    width: "10em",
                    borderRadius: "3em 0",
                    marginTop: "1em",
                    fontSize: "calc(0.7rem + 0.2vw)",
                    border:"none",
                    cursor: loading ? 'wait' : 'pointer',
                  }}
                >
                {language === 'eng' ? "Send Email" : "Envoyer l'e-mail"}  
                </Button>
                <p
              style={{
                fontSize: "calc(0.6rem + 0.4vw)",
                width: "80%",
                margin: " 2em auto 0 auto",
              }}
            >
             {language === 'eng' ? "*note: please check your email junk" : "*remarque : veuillez vérifier vos courriers indésirables"} 
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResendVerifyPage;
